import { GetServerSideProps, InferGetServerSidePropsType } from 'next'

import Layout from '@src/pages/layout'
import { PAGE_PATH } from '@src/quince-site-common/src/constants/pageData'
import SomethingWentWrong from '@src/quince-site-common/src/organisms/somethingWentWrong'
import Addresses from '@src/quince-site-integrated/src/templates/Account/addresses'
import { ServerSideBaseProps } from '@src/server-side/api/api.types'
import { getServerSideBaseProps } from '@src/server-side/get-server-side-props'

export const getServerSideProps = (async ctx => {
  const serverSideBaseProps = await getServerSideBaseProps(ctx, PAGE_PATH.ADDRESSES)

  return serverSideBaseProps
}) satisfies GetServerSideProps<ServerSideBaseProps>

export default function PageAccountsMyProfile(props: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return <Layout {...props}>{props.pageData ? <Addresses data={props.pageData} /> : <SomethingWentWrong />}</Layout>
}
